// extracted by mini-css-extract-plugin
export default {"root":"IModalFeedback_root__Fu2Vf","textWrap":"IModalFeedback_textWrap__m2slj","footer":"IModalFeedback_footer__IcqKr","feedbackAccepted":"IModalFeedback_feedbackAccepted__8MBAe"};